import { treeviaGateway } from '../clients/AxiosClients'

export const vinculaPrognose = async (body) => {
	return await treeviaGateway.post('/ms-prognoses/vinculaprognose/aplicar-prognose', body, {
		timeout: 600000,
	})
}

/**
 * Enfileira o vínculo assíncrono (contrato lean: só IDs). O processamento roda
 * no worker; o acompanhamento é pela central de processamentos (jobs) + sino.
 * body: { prognoseId, idadeDeProjecao, descricao, itens: [{plantioId, inventarioFlorestalId}] }
 */
export const vinculaPrognoseAsync = async (body) => {
	return await treeviaGateway.post('/ms-prognoses/vinculaprognose/aplicar-prognose-async', body, {
		timeout: 60000,
	})
}

/**
 * Desfaz o vínculo da prognose dos plantios selecionados (síncrono: só exclusão
 * e recálculo da média do estrato no banco).
 * body: { itens: [{plantioId, inventarioFlorestalId}] }
 */
export const desvinculaPrognose = async (body) => {
	return await treeviaGateway.post('/ms-prognoses/vinculaprognose/desvincular-prognose', body, {
		timeout: 600000,
	})
}
